import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { injectIntl } from "react-intl";
import Link from "components/link";
import Icon from "components/icon";
import styles from "./styles/link-with-icon.css.js";
import withStyles from "components/with-styles";
import Chip from "components/chip";
import FormHelperText from "components/form/form-helper-text";

const LinkContent = ({ text, icon, classes, showAsChip, label }) =>
  showAsChip ? (
    <Chip
      icon={<Icon className={classes.linkWithIcon_icon} name={icon} />}
      className={classes.linkWithIcon_chip}
      variant="outlined"
      label={text}
    />
  ) : (
    <div>
      <Icon className={classes.linkWithIcon_icon} name={icon} />
      <div className={classes.linkWithIcon_text}>
        <FormHelperText text={label} />
        <span>{text}</span>
      </div>
    </div>
  );

LinkContent.propTypes = {
  /**
   * Mostrar como chip
   */
  showAsChip: PropTypes.bool,
  /**
   * Nombre del icono en material ui
   */
  icon: PropTypes.string,
  /**
   * Texto del enlace
   */
  text: PropTypes.string,
  /**
   * Etiqueta del enlace
   */
  label: PropTypes.string,
};

const LinkWithIcon = ({
  classes,
  className,
  href,
  iconName,
  text,
  label,
  intl,
  showAsChip = false,
  onClick,
  ...props
}) => {
  const handleClick = e => {
    onClick && onClick(e);
    e.stopPropagation();
  };

  const Wrapper = ({ children }) =>
    onClick ? (
      <div className={classes.linkWithIcon_link} onClick={handleClick} color="primary" {...props}>
        {children}
      </div>
    ) : (
      <Link className={classes.linkWithIcon_link} href={href} color="primary" {...props}>
        {children}
      </Link>
    );

  return (
    <div className={cn(classes.linkWithIcon, className)}>
      <Wrapper>
        <LinkContent classes={classes} text={text} icon={iconName} showAsChip={showAsChip} label={label} />
      </Wrapper>
    </div>
  );
};

LinkWithIcon.propTypes = {
  /*
   * Función que se llama al hacer click
   */
  onClick: PropTypes.func,
  /**
   * Mostrar como chip
   */
  showAsChip: PropTypes.bool,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Url del enlace
   */
  href: PropTypes.string,
  /**
   * Nombre del icono en material ui
   */
  iconName: PropTypes.string,
  /**
   * Texto del enlace
   */
  text: PropTypes.string,
  /**
   * Etiqueta del enlace
   */
  label: PropTypes.string,
};

export default injectIntl(withStyles(styles)(LinkWithIcon));
